import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from './api.service';
import {
  CreateGainParameterRequest,
  CreateGainParameterValueRequest,
  GainParameter,
  GainParameterValue,
  UpdateGainParameterRequest,
  UpdateGainParameterValueRequest,
} from '../models/gain-parameter.model';

@Injectable({
  providedIn: 'root',
})
export class GainParameterService {
  constructor(private apiService: ApiService) {}

  getAll(includeDeleted: boolean): Observable<GainParameter[]> {
    return this.apiService.get<GainParameter[]>('/GainParameter/GetAll/', {
      queryParams: { includeDeleted: String(includeDeleted) },
    });
  }

  create(request: CreateGainParameterRequest): Observable<GainParameter> {
    return this.apiService.post<GainParameter>(
      '/GainParameter/Create/',
      request,
    );
  }

  update(request: UpdateGainParameterRequest): Observable<GainParameter> {
    return this.apiService.put<GainParameter>(
      '/GainParameter/Update/',
      request,
    );
  }

  delete(uid: string): Observable<void> {
    return this.apiService.delete<void>(
      `/GainParameter/${encodeURIComponent(uid)}`,
    );
  }

  createValue(
    request: CreateGainParameterValueRequest,
  ): Observable<GainParameterValue> {
    return this.apiService.post<GainParameterValue>(
      '/GainParameterValue/Create/',
      request,
    );
  }

  updateValue(
    request: UpdateGainParameterValueRequest,
  ): Observable<GainParameterValue> {
    return this.apiService.put<GainParameterValue>(
      '/GainParameterValue/Update/',
      request,
    );
  }

  deleteValue(uid: string): Observable<void> {
    return this.apiService.delete<void>(
      `/GainParameterValue/${encodeURIComponent(uid)}`,
    );
  }
}
